import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditExpenseForm } from "../../components/expense";

export const AddEditExpense = () => {
  const { expenseId } = useParams();

  return (
    <>
      <PageLayout>
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader title={expenseId ? "Edit Expense" : "Add Expense"} />
        </Box>

        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <AddEditExpenseForm />
        </Box>
      </PageLayout>
    </>
  );
};
